<template>
  <div class="page-view">
    <div class="header-row">
      <div>
        <h2>录单字段配置</h2>
        <p>配置后台手工录单时每个字段是否必填，仅超级管理员可修改。</p>
      </div>
      <el-button type="primary" @click="saveSettings">保存配置</el-button>
    </div>

    <div class="brand-card table-card">
      <el-table :data="items" stripe>
        <el-table-column prop="field_label" label="字段名称" min-width="220" />
        <el-table-column label="是否必填" width="180">
          <template slot-scope="{ row }">
            <el-switch v-model="row.is_required" />
          </template>
        </el-table-column>
        <el-table-column label="说明" min-width="360">
          <template slot-scope="{ row }">
            <span v-if="row.field_key === 'address'">收件地址为省、市整体校验，区县可选。</span>
            <span v-else>开启后，手工录单提交时必须填写该字段。</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { fetchManualOrderFieldSettings, updateManualOrderFieldSettings } from "../api/orders";

export default {
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    async loadSettings() {
      const { data } = await fetchManualOrderFieldSettings();
      this.items = data.items || [];
    },
    async saveSettings() {
      await updateManualOrderFieldSettings({
        items: this.items.map((item) => ({
          field_key: item.field_key,
          is_required: item.is_required,
        })),
      });
      this.$message.success("录单字段配置已保存");
      this.loadSettings();
    },
  },
};
</script>

<style scoped>
</style>
